import React, { useRef, useState } from 'react';
import { Card, Grid, Typography, Link } from '@material-ui/core';

import { JobSummary } from '../../../../components/JobSummary';
import { PublishableStatusComponent } from '../../../../components/PublishableStatusComponent';
import { UploadButton } from '../../../../components/UploadButtonComponent';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { GQLAccessoryModel, GQLJobSummary } from '@jewelutions/core-crm-server-api-client-domain';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';
import { SvgDisplay } from '../../../../components';
import { Box } from '../../../../types-hack';
interface IProps {
  accessoryId: string;
  model: GQLAccessoryModel;
}

const ModelDetailsCad: React.FC<IProps> = ({ accessoryId, model }) => {
  const [cadFile, setCadFile] = useState(null as any);
  const [iconFile, setIconFile] = useState(null as any);
  const cadJobImportStatus = useRef(null);

  const [
    uploadCad,
    { error: errorUploadingCadFile, loading: uploadingCadFile }
  ] = GQLOperationBuilder.accessory.importAccessoryModelCadFile();
  const [
    uploadIcon,
    { error: errorUploadingIcon, loading: uploadingIcon }
  ] = GQLOperationBuilder.accessory.importAccessoryModelIconFile();

  const {
    data: cadImportJobSummaryData,
    refetch: refetchCadImportJobSummaryData
  } = GQLOperationBuilder.accessory.importAccessoryModelCadFileJobs({
    accessoryId: accessoryId,
    accessoryModelId: model.id
  });

  return (
    <Card style={{ marginBottom: '8px' }}>
      <Box p={5}>
        <Grid container direction="row">
          <Grid item xs={3}>
            <Grid container direction="column">
              <Typography variant={'h6'}>Accessory Model CAD</Typography>
              <PublishableStatusComponent
                status={model.hasCadFileValid}
                text="Accessory model CAD validity"
              ></PublishableStatusComponent>
              <span>Last model CAD import job status: </span>
              <JobSummary
                ref={cadJobImportStatus}
                jobSummary={
                  GQLOperationBuilder.accessory.jobSummaryArrayFromResponse(cadImportJobSummaryData).length >
                  0
                    ? GQLOperationBuilder.accessory.jobSummaryArrayFromResponse(cadImportJobSummaryData)[0]
                    : ((undefined as unknown) as GQLJobSummary)
                }
              />
              <UploadButton
                id={`modelDetailsImportNewCAD1_${accessoryId}_${model.id}`}
                importButtonLabel={'Import new CAD'}
                fileTypesAsCsv={'.3dm'}
                onFileSelected={(file: File) => {
                  setCadFile(file);
                  const variables = {
                    accessoryId: accessoryId,
                    accessoryModelId: model.id,
                    file
                  };
                  uploadCad({ variables }).then(_result => {
                    successNotification(toast, 'Accessory CAD import job created successfully', () => {});
                    window.location.reload();
                  });
                }}
              />
              <PublishableStatusComponent
                status={model.hasIconValid}
                text="Accessory model icon"
              ></PublishableStatusComponent>
              <Grid item>
                {model.hasIconValid && (
                  <React.Fragment>
                    <SvgDisplay style={{ width: `128px`, height: `128px` }} url={model.icon.url!} />
                    <Link href={model.icon.url!}>Download</Link>
                  </React.Fragment>
                )}
                {!model.hasIconValid && (
                  <img style={{ color: 'red' }} height={80} src={'/images/x-mark-128.png'}></img>
                )}
                <UploadButton
                  id={`modelDetailsImportNewIcon1_${accessoryId}_${model.id}`}
                  importButtonLabel={'Import new icon'}
                  fileTypesAsCsv={'.svg,.png'}
                  onFileSelected={(file: File) => {
                    setIconFile(file);
                    const variables = {
                      accessoryId: accessoryId,
                      accessoryModelId: model.id,
                      file
                    };
                    uploadIcon({ variables }).then(_result => {
                      successNotification(toast, 'Accessory icon uploaded successfully', () => {});
                      window.location.reload();
                    });
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default ModelDetailsCad;
